var u = Object.defineProperty;
var d = (h, t, i) => t in h ? u(h, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : h[t] = i;
var c = (h, t, i) => (d(h, typeof t != "symbol" ? t + "" : t, i), i);
function g(h, t) {
  return new o(h).sanitize(t);
}
class o {
  constructor(t) {
    c(this, "str", "");
    c(this, "i", 0);
    c(this, "allowedTags", [
      "div",
      "span",
      "b",
      "u",
      "i",
      "strong",
      "em",
      "strike",
      "code",
      "p",
      "blockquote",
      "nl",
      "caption",
      "pre",
      "a",
      "br",
      "hr",
      "img",
      "ul",
      "ol",
      "nav",
      "li",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "menu",
      "table",
      "td",
      "tr",
      "thead",
      "tbody",
      "tfoot",
      "th"
    ]);
    // full list here:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes
    c(this, "allowedAttributes", [
      "align",
      "alt",
      "bgcolor",
      "border",
      "class",
      "color",
      "colspan",
      "dir",
      "headers",
      "height",
      "hidden",
      "href",
      "size",
      "hreflang",
      "id",
      "lang",
      "rel",
      "reversed",
      "rowspan",
      "shape",
      "sizes",
      "spellcheck",
      "src",
      "srcset",
      "style",
      "summary",
      "title",
      "translate",
      "type",
      "width",
      "data",
      "data-*"
    ]);
    this.str = t, this.i = 0;
  }
  sanitize(t) {
    t = t || {};
    let i = t.allowedTags || this.allowedTags;
    (!i || !i.includes) && (i = !1);
    let s = t.allowedAttributes || this.allowedAttributes;
    for ((!s || !s.includes) && (s = !1); this.i < this.str.length; ) {
      if (!this.isTag()) {
        this.i++;
        continue;
      }
      const e = this.i, a = this.readTagName();
      let l;
      if (i === !1 ? l = !0 : l = i.includes(a), !l) {
        this.cutTag(e);
        continue;
      }
      this.stripAttributes(a, s), this.skipSpace();
      let r = this.str[this.i];
      r == "/" && (this.i++, r = this.str[this.i], this.skipSpace()), r != ">" && r != "¾" && this.cutTag(e);
    }
    return this.str;
  }
  isTag() {
    const t = this.str[this.i];
    return t == "<" || t == "¼";
  }
  readTagName() {
    let t = this.str[this.i];
    (t == "<" || t == "¼") && this.i++, this.skipSpace(), t = this.str[this.i], t == "/" && (this.i++, this.skipSpace());
    let i = "";
    for (; this.i < this.str.length; ) {
      const s = this.str[this.i];
      if (/\s|>|\/|¾/.test(s))
        break;
      i += s, this.i++;
    }
    return i.toLowerCase();
  }
  cutTag(t) {
    this._readToEndTag(), this.cutSubstring(t, this.i);
  }
  _readToEndTag() {
    if (this.i >= this.str.length)
      return;
    this.skipSpace();
    let t = this.str[this.i];
    if (t == "/" && (this.i++, this.skipSpace()), t = this.str[this.i], t == ">" || t == "¾") {
      this.i++;
      return;
    }
    this.skipSpace(), this.isAttr() ? (this.readAttrName(), this.isAttrValue() && this.readAttrValue()) : this.i++, this._readToEndTag();
  }
  stripAttributes(t, i) {
    if (this.skipSpace(), !this.isAttr())
      return;
    const s = this.i, e = this.readAttrName();
    let a = null;
    this.isAttrValue() && (a = this.readAttrValue());
    const l = this.i;
    let r = i.includes(e);
    (e == "src" || e == "href") && (a && this.isValidURL(a) || (r = !1)), e == "style" && a && (this.isValidStyle(a) || (r = !1)), r || this.cutSubstring(s, l), this.stripAttributes(t, i);
  }
  isValidStyle(t) {
    return !0;
  }
  isValidURL(t) {
    return /[\x00-\x20]/g.test(t) || /[¼¾]/.test(t) || /<!--.*?-->/.test(t) ? !1 : (t = t.trim(), /^(#|http|\/)/.test(t));
  }
  readAttrValue() {
    this.skipSpace();
    let t = this.str[this.i];
    t == "=" && (this.i++, this.skipSpace()), t = this.str[this.i];
    let i = !1;
    (t == '"' || t == "'" || t == "`") && (i = t, this.i++);
    let s = "";
    for (; this.i < this.str.length; ) {
      const e = this.str[this.i];
      if (i)
        if (i == e) {
          this.i++;
          break;
        } else
          s += e, this.i++;
      else {
        if (/[\s>¾]/.test(e))
          break;
        s += e, this.i++;
      }
    }
    return s;
  }
  isAttrValue() {
    const t = this.str.slice(this.i);
    return /^\s*=\s*/.test(t);
  }
  skipSpace() {
    for (; this.i < this.str.length; ) {
      const t = this.str[this.i];
      if (/\s/.test(t))
        this.i++;
      else
        break;
    }
  }
  readAttrName() {
    let t = "";
    for (; this.i < this.str.length; ) {
      const i = this.str[this.i];
      if (/\s|=|>|¾/.test(i))
        break;
      t += i, this.i++;
    }
    return t.toLowerCase();
  }
  isAttr() {
    const t = this.str[this.i];
    return (
      // if char is null, then test return true
      // stop recursion
      t && /[^</>\s¼¾]/.test(t)
    );
  }
  cutSubstring(t, i) {
    this.str = this.str.slice(0, t) + this.str.slice(i), this.i -= i - t;
  }
}
export {
  g as sanitize
};
